import SubcategoryPage from '@/components/template/SubcategoryPage';

const TwisterStool = () => {
  const products = [
    {
      title: "Twister Stool Light",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/proizvodi/twister-stool-light"
    },
    {
      title: "Twister Stool Dark",
      imageSrc: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80",
      url: "/proizvodi/twister-stool-dark"
    },
    {
      title: "Twister Stool Premium",
      imageSrc: "https://images.unsplash.com/photo-1579656381253-c2e57a7d7c81?auto=format&fit=crop&q=80",
      url: "/proizvodi/twister-stool-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Twister Stool"
      description="Dinamični in edinstveni Twister stolčki, ki združujejo udobje in umetniški izraz."
      heroImage="https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TwisterStool;